module.exports = __webpack_public_path__ + "img/banner.8e7c6dac.jpg";